import React, { useCallback, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import MizanReading from './MizanReading';
import UploadedTrialBalanceFilesList from './UploadedTrialBalanceFilesList';

const TrialBalanceFromFileTab = ({ uploadedMizansRefreshToken = 0 }) => {
  const [externalViewingMizanId, setExternalViewingMizanId] = useState(null);
  const [externalViewingFileName, setExternalViewingFileName] = useState('');
  const [externalViewingDonem, setExternalViewingDonem] = useState(null);
  const [externalViewingDateRange, setExternalViewingDateRange] = useState(null);
  const [externalViewingPeriodStart, setExternalViewingPeriodStart] = useState(null);
  const [externalViewingPeriodEnd, setExternalViewingPeriodEnd] = useState(null);
  const [externalViewingRefreshToken, setExternalViewingRefreshToken] = useState(0);
  const [pendingAutoSelectLatest, setPendingAutoSelectLatest] = useState(false);

  const handleView = useCallback((selected) => {
    setExternalViewingMizanId(selected?.mizanId || null);
    setExternalViewingFileName(selected?.fileName || '');
    setExternalViewingDonem(selected?.donem ?? null);
    setExternalViewingDateRange(selected?.tarihAraligi ?? null);
    setExternalViewingPeriodStart(selected?.periodCoveredStart ?? null);
    setExternalViewingPeriodEnd(selected?.periodCoveredEnd ?? null);
    setExternalViewingRefreshToken((t) => t + 1);
  }, []);

  const handleDeleted = useCallback(
    (deletedId) => {
      setExternalViewingMizanId((current) => (current === deletedId ? null : current));
    },
    []
  );

  useEffect(() => {
    if (uploadedMizansRefreshToken > 0) {
      setPendingAutoSelectLatest(true);
    }
  }, [uploadedMizansRefreshToken]);

  const handleListLoaded = useCallback(
    (list) => {
      if (!pendingAutoSelectLatest) return;
      if (!Array.isArray(list) || list.length === 0) return;

      const latest = list[0];
      handleView({
        mizanId: latest?.mizanId,
        fileName: latest?.fileName || latest?.generatedFileName || '',
        donem: latest?.donem ?? null,
        tarihAraligi: latest?.tarihAraligi ?? null,
        periodCoveredStart: latest?.periodCoveredStart ?? latest?.periodStart ?? null,
        periodCoveredEnd: latest?.periodCoveredEnd ?? latest?.periodEnd ?? null,
      });
      setPendingAutoSelectLatest(false);
    },
    [pendingAutoSelectLatest, handleView]
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <UploadedTrialBalanceFilesList
        refreshToken={uploadedMizansRefreshToken}
        onViewMizan={handleView}
        onDeletedMizanId={handleDeleted}
        onListLoaded={handleListLoaded}
      />

      <Box sx={{ mt: 2 }}>
        <MizanReading
          hideUploadedFilesList
          externalViewingMizanId={externalViewingMizanId}
          externalViewingFileName={externalViewingFileName}
          externalViewingDonem={externalViewingDonem}
          externalViewingDateRange={externalViewingDateRange}
          externalViewingPeriodStart={externalViewingPeriodStart}
          externalViewingPeriodEnd={externalViewingPeriodEnd}
          externalViewingRefreshToken={externalViewingRefreshToken}
          embedded
        />
      </Box>
    </Box>
  );
};

export default TrialBalanceFromFileTab;

